import { CheckCircle } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import { ROUTE_PATHS } from '@/config/constants';

export function Success() {
  const navigate = useNavigate();

  function handleDashboardClick() {
    navigate(ROUTE_PATHS.ADMIN_DASHBOARD);
  }
  function handleUsersClick() {
    navigate(ROUTE_PATHS.ADMIN_USERS);
  }

  return (
    <div className="container mx-auto py-10">
      <Card className="mx-auto w-full max-w-md">
        <CardHeader>
          <div className="mb-4 flex items-center justify-center">
            <CheckCircle className="h-16 w-16 text-green-500" />
          </div>

          <CardTitle className="text-center">User Edit Successfully!</CardTitle>
        </CardHeader>

        <CardContent className="flex flex-col items-center">
          <p className="mb-6 text-center">
            The user information has been updated.
          </p>
          <div className="flex space-x-4">
            <Button variant="outline" onClick={handleDashboardClick}>
              Back to Dashboard
            </Button>
            <Button onClick={handleUsersClick}>View All Users</Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
